export const bidTypes = Object.freeze({
  PRE: 'pre',
  LIVE: 'live',
  AFTER: 'after',
})
